import {
  CreateOptimizedTerritoriesAdditionalOption, type CreateOptimizedTerritoryAdditionalStepInterlock,
} from '~/sidebar/sidebarApps/mapTools/boundary/loadBoundaryPane/createCustomBoundaryPane/createBoundaryGroupFromAIModal/modalSteps/additionalOptions.component';

type InterlockParams = {
  interlocks: ReadonlyArray<CreateOptimizedTerritoryAdditionalStepInterlock>;
  respectSalesLocations: boolean;
  respectPrevTerritories: boolean;
  useNumberOfTerritories: boolean;
  constraintsEnabled: boolean;
};

export const useAdditionalStepInterlocks = ({
  interlocks, constraintsEnabled, useNumberOfTerritories,
  respectPrevTerritories, respectSalesLocations,
}: InterlockParams) => {
  const items: Array<{ type: CreateOptimizedTerritoriesAdditionalOption; isChecked: boolean }> = [
    {
      type: CreateOptimizedTerritoriesAdditionalOption.SalesReps,
      isChecked: respectSalesLocations,
    },
    {
      type: CreateOptimizedTerritoriesAdditionalOption.RespectPreviousTerritories,
      isChecked: respectPrevTerritories,
    },
    {
      type: CreateOptimizedTerritoriesAdditionalOption.NumerOfTerritories,
      isChecked: useNumberOfTerritories,
    },
    {
      type: CreateOptimizedTerritoriesAdditionalOption.Constraints,
      isChecked: constraintsEnabled,
    },
  ];

  const checkedItems = items.filter(item => item.isChecked).map(item => item.type);

  const getDisabledReason = (option: CreateOptimizedTerritoriesAdditionalOption): string | null => {
    return interlocks.find(rule =>
      rule.item === option && checkedItems.includes(rule.lockingItem),
    )?.reason ?? null;
  };

  const salesRepsDisabledReason = getDisabledReason(CreateOptimizedTerritoriesAdditionalOption.SalesReps);
  const respectPreviousTerritoriesDisabledReason = getDisabledReason(CreateOptimizedTerritoriesAdditionalOption.RespectPreviousTerritories);
  const numberOfTerritoriesDisabledReason = getDisabledReason(CreateOptimizedTerritoriesAdditionalOption.NumerOfTerritories);
  const constraintsDisabledReason = getDisabledReason(CreateOptimizedTerritoriesAdditionalOption.Constraints);

  return {
    salesRepsDisabledReason,
    respectPreviousTerritoriesDisabledReason,
    numberOfTerritoriesDisabledReason,
    constraintsDisabledReason,
  };
};
